// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1dhF2","inputWrap":"CustomTip_inputWrap__nxDpn"};